import React, { useMemo, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Header from './../../compoments/Header';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import api from './../../services/axios'
import AlertDialog from './../../compoments/AlertDialog'
import Typography from '@material-ui/core/Typography';
import { Breadcrumbs } from '@material-ui/core';
import { Link } from 'react-router-dom'
import { Redirect } from 'react-router'
import AudioUpload from './../../compoments/AudioUpload'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import Select from '@material-ui/core/Select'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Checkbox from '@material-ui/core/Checkbox'
import MenuItem from '@material-ui/core/MenuItem'
import Input from '@material-ui/core/Input'
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Loading from './../../compoments/Loading'
import { baseURL } from './../../env.js'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import CommentIcon from '@material-ui/icons/Comment';
import { MuiPickersUtilsProvider, KeyboardTimePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  appBarSpacer: theme.mixins.toolbar,
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  disabled: {
    padding: 30,
    backgroundColor: 'red'
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 220,
    maxWidth: 700,
  },
}));

export default function UraUpdate({ history, match }) {

  const rota = 'ura';
  const roleName = 'Ura';
  const [redirect, setRedirect] = React.useState(false);
  const [name, setName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [birthday, setBirthday] = React.useState('');
  const [stateAddress, setStateAddress] = React.useState('');
  const [city, setCity] = React.useState('');
  const [message, setMessage] = React.useState(false);
  const [alertTitle, setAlertTitle] = React.useState('');
  const [thumbnail, setThumbnail] = React.useState(null);
  const [croppedAreaPixels, setCroppedAreaPixels] = React.useState(null);
  const [filas, setFilas] = React.useState([]);
  const [uras, setUras] = React.useState([]);
  const [ura, setUra] = React.useState({});
  const [filasSelected, setFilasSelected] = React.useState([]);
  const [cod, setCod] = React.useState(null);
  const [showCod, setShowCod] = React.useState(false);
  const [phoneKeysActions, setPhoneKeysActions] = React.useState([]);
  const [phoneKeys, setPhoneKeys] = React.useState([]);
  const [phoneKeysActionIds, setPhoneKeysActionIds] = React.useState([]);
  const [audioFile, setAudioFile] = React.useState({});
  const [audioLoaded, setAudioLoaded] = React.useState({});
  const [id, setId] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [weekdaySelected, setWeekdaySelected] = React.useState('');
  const [selectedDateStart, setSelectedDateStart] = React.useState(new Date('2014-08-18T21:11:54'));
  const [selectedDateEnd, setSelectedDateEnd] = React.useState(new Date('2014-08-18T21:11:54'));
  const [uraWeekdays, setUraWeekdays] = React.useState([]);
  const [weekdays, setWeekdays] = React.useState([]);
  const [weekdaysDeleted, setWeekdaysDeleted] = React.useState([]);
  const [tbRamais, setTbRamais] = React.useState([]);
  const [ramal, setRamal] = React.useState('');
  const [integrations, setIntegrations] = React.useState([
    { id: 1,  name: 'SMS'},
    { id: 2,  name: 'WHATSAPP'},
    { id: 3,  name: 'EMAIL'},
    { id: 4,  name: 'API'},
  ]);

  const getRndInteger = (min, max) => {
    return Math.floor(Math.random() * (max - min) ) + min;
  }
  

  const [password, setPassword] = React.useState(getRndInteger(100000, 999999));

  const [showPassword, setShowPassword] = React.useState(null);

  const loadData = async () => {
    setLoading(true);
    const dataTbRamais = await api.get('/v1/tb-ramais/');
    setTbRamais(dataTbRamais.data.data)
    const dataPhoneKeys = await api.get('/v1/phone-keys/')
    const dataPhoneKeysActions = await api.get('/v1/phone-keys-actions/')
    setPhoneKeys(dataPhoneKeys.data.data);
    setPhoneKeysActions(dataPhoneKeysActions.data.data);
    const dataFilas = await api.get('/v1/queue-table')
    setFilas(dataFilas.data.data)
    const dataUra = await api.get('/v1/ura/' + match.params.id)
    setUraWeekdays(dataUra.data.weekdays)
    setRamal(dataUra.data.ddrUra)
    setAudioLoaded({name: dataUra.data.fileVoiceName, uri: baseURL+dataUra.data.fileVoice })
    setId(dataUra.data.id);
    setPhoneKeysActionIds(dataUra.data.phoneKeys);
    setUra(dataUra.data)
    setName(dataUra.data.name)
    const dataUras = await api.get('/v1/ura/')
    setUras(dataUras.data.data)
    const dataWeekdays = await api.get('/v1/weekdays')
    setWeekdays(dataWeekdays.data.data)
    setLoading(false);
    // setFilas(data.data.data)
  }

  const handleWeekdaySelected = (e) => {
    setWeekdaySelected(e.target.value);
  }

  const handleDateStartChange = (date) => {
    setSelectedDateStart(date);
  };

  const handleDateEndChange = (date) => {
    setSelectedDateEnd(date);
  };

  const handleDeleteWeekday = (k, uW) => {
    if(uW.id){
      const weekdaysDeletedData = weekdaysDeleted;
      weekdaysDeletedData.push(uW.id);
      setWeekdaysDeleted(weekdaysDeletedData)
    }
    const uraWeekdaysData = uraWeekdays;
    uraWeekdaysData.splice(k, 1);
    setUraWeekdays(uraWeekdaysData);
    setWeekdaySelected(1);
    setTimeout(()=>{
      setWeekdaySelected('');
    }, 10);
  }

  const handleAddWeekday = (date) => {
    const selectedDateStartDt = new Date(selectedDateStart);
    const selectedDateStartH = selectedDateStartDt.getHours();
    const selectedDateStartM = ('0' + selectedDateStartDt.getMinutes()).slice(-2);
    const selectedDateEndDt = new Date(selectedDateEnd);
    const selectedDateEndH = selectedDateEndDt.getHours();
    const selectedDateEndM = ('0' + selectedDateEndDt.getMinutes()).slice(-2);

    const weekdayFind = weekdays.find((wd)=>wd.id.toString()===weekdaySelected.toString());
    const dt = {
      weekdayId: weekdayFind.id.toString(),
      start: selectedDateStartH+':'+selectedDateStartM,
      end: selectedDateEndH+':'+selectedDateEndM,
      weekdayName: weekdayFind.name,
    }
    const uraWeekdaysData = uraWeekdays;
    uraWeekdaysData.push(dt);
    setUraWeekdays(uraWeekdaysData);
    setWeekdaySelected('');
  };

  useEffect(() => {
    loadData()
  }, []);

  const audioBlob = useMemo(() => {
    return audioFile && audioFile.name ? URL.createObjectURL(audioFile) : null
  }, [audioFile])

  const save = async () => {

    setLoading(true);

    const data = new FormData();

    data.append(
      'name', 
      name
    );

    data.append(
      'ddrUra', 
      ramal
    );
    
    if(audioFile && audioFile.name){
      data.append('fileVoice', audioFile);
    }

    let items = [];

    phoneKeysActionIds.map((phoneKeyActionId) => {
      items.push({
        phoneKeyId: phoneKeyActionId.phoneKeyId.toString(),
        phoneKeyAction: phoneKeyActionId.phoneKeyActionId.toString(),
        value: phoneKeyActionId.value.toString(),
      });
    });

    items = JSON.stringify(items);
    
    data.append(
      'items', 
      items
    );
    

    data.append(
      'weekdays', 
      JSON.stringify(uraWeekdays)
    );

    data.append(
      'weekdaysDeleted', 
      JSON.stringify(weekdaysDeleted)
    );

    data.append('_method', 'PUT')

    try {                                                               
      const res = await api.post('/v1/ura/'+ id, data, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data',
        }
      })
      setAlertTitle('')
      history.push('/' + rota)
    } catch(error) {
      setLoading(false);
      setAlertTitle('Erro')
      const errorLog = error.response && error.response.data && error.response.data.errors
        && error.response.data.errors[0] && error.response.data.errors[0].message || 'Erro'
      setMessage(errorLog)
    }
  }

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const renderLabel = (labelText) => <h3 style={{marginBottom: -20}}>{labelText}</h3>

  const renderSubSelect = (itemSelect) => {
    const findItemSelected = phoneKeysActionIds.find((i) => {
      return i.phoneKeyId===itemSelect.id && i.phoneKeyActionId.toString();
    });
    const sValue = findItemSelected && findItemSelected.phoneKeyActionId && findItemSelected.phoneKeyActionId.toString() || '';
    switch (sValue) {
      case '1':
        return <FormControl className={classes.formControl}>
          <InputLabel id="demo-simple-select-label">Fila</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={handleGetSubValue(findItemSelected)}
            onChange={(e) => handlePhoneKeysActionIdsValue(e, findItemSelected)}
          >{filas.map(name => (
            <MenuItem value={name.id}>{name.name}</MenuItem>
            ))}
          </Select>
        </FormControl>        
        break;
        case '2':
          return <FormControl className={classes.formControl}>
            <InputLabel id="demo-simple-select-label">Submenu</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={handleGetSubValue(findItemSelected)}
              onChange={(e) => handlePhoneKeysActionIdsValue(e, findItemSelected)}
            >{uras.map(uraItem => (
              <MenuItem value={uraItem.id}>{uraItem.id} - {uraItem.name}</MenuItem>
              ))}
            </Select>
          </FormControl>        
          break;        
        case '5':
          return <FormControl className={classes.formControl}>
            <InputLabel id="demo-simple-select-label">Integrações</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={handleGetSubValue(findItemSelected)}
              onChange={(e) => handlePhoneKeysActionIdsValue(e, findItemSelected)}
            >{integrations.map(uraItem => (
              <MenuItem value={uraItem.id}>{uraItem.name}</MenuItem>
              ))}
            </Select>
          </FormControl>        
          break;
      default:
        return <FormControl className={classes.formControl}>
          <InputLabel id="demo-simple-select-label">&nbsp;</InputLabel>
          <Select
            disabled="true"
            labelId="demo-simple-select-label"
            id="demo-simple-select"
          >
            <MenuItem value=""> -- </MenuItem>
          </Select>
        </FormControl>      
        break;
    }
  }

  const handlePhoneKeysActionIds = (e, pK) => {
    const phoneKeysActionIdsData = phoneKeysActionIds;
    const findData = phoneKeysActionIdsData.find((i) => 
      i.phoneKeyId.toString()===pK.id.toString());
    if(findData && findData.phoneKeyId){
      const changeData = phoneKeysActionIdsData.map((i) => {
        if(i.phoneKeyId.toString()===pK.id.toString()){
          i.phoneKeyActionId = e.target.value;
          i.value = '';
        }
        return i
      });
      setPhoneKeysActionIds(changeData);

    }else{
      phoneKeysActionIdsData.push({
        phoneKeyActionId: e.target.value,
        phoneKeyId: pK.id,
        value: '',
      });
      setPhoneKeysActionIds(phoneKeysActionIdsData);
    }

    setWeekdaySelected(1);
    setTimeout(()=>{
      setWeekdaySelected('');
    }, 10);
  }

  const handlePhoneKeysActionIdsValue = (e, vK) => {
    const phoneKeysActionIdsData = phoneKeysActionIds;
    const changeData = phoneKeysActionIdsData.map((i) => {
      if(i.phoneKeyId===vK.phoneKeyId){
        i.value = e.target.value;
      }
      return i
    });
    setPhoneKeysActionIds(changeData);
  }

  const handleGetValue = (item) => {
    const findItem = phoneKeysActionIds.find((i) => {
      return i.phoneKeyId.toString()===item.id.toString() && i.phoneKeyActionId;
    });    
    return findItem && findItem.phoneKeyActionId.toString();
  }
  const handleGetSubValue = (subItem) => {
    const findItem = phoneKeysActionIds.find((i) => {
      return i.phoneKeyId.toString()===subItem.phoneKeyId.toString() && i.value;
    });    
    return findItem && findItem.value && findItem.value.toString();
  }

  const classes = useStyles();

  return (
    <div className={classes.root}>
      {redirect && <Redirect to={redirect} />}
      <CssBaseline />
      <Header titleHeader={'Editar Clientes'} />
      {/* CONTEUDO */}
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          {loading ?  <Loading /> : 
          <Grid container spacing={3}>
            {/* Recent Orders */}
            <Grid item xs={12}>
              <Breadcrumbs aria-label="breadcrumb">
                <Link color="inherit" to={`/${rota}`}>
                  {roleName}
                </Link>
                <Typography color="textPrimary">Editar</Typography>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12}>
              <Paper className={classes.paper}>
                <form className={classes.form} noValidate>
                  <Grid item xs={12}>
                    <Grid item xs={6}>
                      { audioFile && audioFile.name &&
                      <figure>
                        <figcaption>{audioFile.name}</figcaption>
                          <audio
                              controls
                              src={audioBlob}>
                                  Your browser does not support the
                                  <code>audio</code> element.
                          </audio>
                          <DeleteForeverIcon color="secondary" onClick={()=> { 
                            loadData();
                            setAudioFile({});
                          }} />
                      </figure>
                      }
                      { audioLoaded && audioLoaded.name &&
                      <figure>
                        <figcaption>{audioLoaded.name}</figcaption>
                          <audio
                              controls
                              src={audioLoaded.uri}>
                                  Your browser does not support the
                                  <code>audio</code> element.
                          </audio>
                        { !(audioFile && audioFile.name)  &&
                          <AudioUpload
                            iconFontSize={'40'}
                            buttomText={'Alterar áudio'}
                            onChange={event => { 
                              setAudioFile(event.target.files[0]) 
                              setAudioLoaded({}) 
                            } }
                          />
                          }
                      </figure>
                      }
                    </Grid>
                  </Grid>                  
                  <Grid item xs={6} style={{marginTop: 25}}>
                      <TextField
                        variant="outlined"
                        required
                        fullWidth
                        id="name"
                        label="Nome"
                        name="name"
                        autoComplete="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </Grid>     
                    <Grid item xs={12} style={{marginBottom: 20, marginTop: 20}}>
                      <FormControl className={classes.formControl}>
                        <InputLabel id="demo-simple-select-label">Ramal</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={ramal && ramal.toString()}
                          onChange={(e) => setRamal(e.target.value)}
                        >
                          <MenuItem value={''}>
                            Nenhum
                          </MenuItem>
                          {tbRamais.map(tbRamal => (
                          <MenuItem value={tbRamal.name.toString()}>
                            {tbRamal.name}
                          </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>        
                    {phoneKeys.map( (pK, k) => (
                      <>
                      <Grid item xs={12}>
                        <FormControl className={classes.formControl} >
                          { k.toString() === '0' && renderLabel('Ação') }
                        </FormControl>
                        <FormControl className={classes.formControl} >
                          { k.toString() === '0' && renderLabel('Opção') }
                        </FormControl>
                      </Grid>
                      <Grid item xs={12}>
                        <FormControl className={classes.formControl}>
                          <InputLabel id="demo-simple-select-label">{pK.name}</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={handleGetValue(pK)}
                            onChange={(e) => handlePhoneKeysActionIds(e, pK)}
                          >
                            <MenuItem value={''}>
                              Nenhum
                            </MenuItem>
                            {phoneKeysActions.map(phoneKeyAction => (
                            <MenuItem value={phoneKeyAction.id.toString()}>
                              {phoneKeyAction.name}
                            </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {renderSubSelect(pK)}
                      </Grid>
                      </>
                    ))}

<Grid item xs={12}>
                      <FormControl className={classes.formControl}>
                        <InputLabel id="demo-simple-select-label">Dias e horários na semana</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={weekdaySelected}
                          onChange={(e) => handleWeekdaySelected(e)}
                        >
                          <MenuItem value=''>Nenhum</MenuItem>
                          {weekdays.map(name => (
                          <MenuItem value={name.id}>{name.name}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      { weekdaySelected !== '' &&
                        <FormControl className={classes.formControl} style={{marginTop: -8}}>
                          <MuiPickersUtilsProvider utils={DateFnsUtils} >
                                  <KeyboardTimePicker
                                    margin="normal"
                                    id="time-picker"
                                    label="Hora inicial"
                                    value={selectedDateStart}
                                    onChange={handleDateStartChange}
                                    KeyboardButtonProps={{
                                    'aria-label': 'change time',
                                    }}
                                  />
                                  <KeyboardTimePicker
                                    margin="normal"
                                    id="time-picker"
                                    label="Hora final"
                                    value={selectedDateEnd}
                                    onChange={handleDateEndChange}
                                    KeyboardButtonProps={{
                                    'aria-label': 'change time',
                                    }}
                                  />
                          </MuiPickersUtilsProvider>
                          <Button variant="contained" 
                            onClick={handleAddWeekday}
                          >Adicionar</Button>
                        </FormControl>
                      }
                    </Grid>

                    <Grid item xs={6} style={{marginBottom: 20}}>
                    { uraWeekdays.map((uW, k)=>{
                      return <ListItem key={k}
                      // onClick={handleToggle(value)}
                      >
                        {/* <ListItemIcon>
                          <Checkbox
                            edge="start"
                            checked={true}
                            tabIndex={-1}
                            disableRipple
                            inputProps={{ 'aria-labelledby': 1 }}
                          />
                        </ListItemIcon> */}
                        <ListItemText id={k} primary={uW.weekdayName+' de '+uW.start+' às '+uW.end} />
                        <ListItemSecondaryAction>
                          <IconButton edge="end" aria-label="delete">                            
                              <DeleteForeverIcon color="secondary" 
                                onClick={()=> { 
                                  handleDeleteWeekday(k, uW)
                                }} 
                              />
                          </IconButton>
                        </ListItemSecondaryAction>
                      </ListItem>

                    })}
                    </Grid>
                  
                  <Grid container spacing={2}>                   
                    <Grid item xs={6}>
                      <Button
                        onClick={() => {
                          setRedirect(`/${rota}`)
                        }}
                        type="button"
                        variant="contained"
                        color="default"
                        // className={classes.submit}
                        style={{ marginRight: 30 }}
                      >
                        Cancelar
                      </Button>
                      <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        onClick={save}
                      >
                        Salvar
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </Paper>
            </Grid>
          </Grid>
          }
          <AlertDialog message={message}
            onClose={() => setMessage(false)}
            title={alertTitle}
            buttonSuccessText={'OK'}
          />
        </Container>
      </main>
    </div>
  );
}